import appNav from './_components/_app-nav.js';
import appModal from './_components/_app-modal.js';
import appToggleParent from './_components/_app-toggle-parent.js';
import appAccordian from './_components/_app-accordian.js';
import imageModal from './_components/_image-modal.js';
import scrollAnimation from './_components/_scroll-animation.js';
import getDemo from './_components/_get-demo.js';
import csrf from './_components/_csrf.js';
import formFiller from './_components/_form-filler.js';

export default function appStart() {
    appNav.init();
    csrf.init();
    formFiller.init();
    getDemo.init();
    appModal.init();
    appToggleParent.init();
    appAccordian.init();
    imageModal.init();
    scrollAnimation.init();
}

document.addEventListener('DOMContentLoaded', () => {
    appStart();
});
